(function () {
  var MOBILE_MENU_STYLE_ID = 'yt-mobile-menu-drawer-styles';

  function injectMobileMenuStyles() {
    if (document.getElementById(MOBILE_MENU_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = MOBILE_MENU_STYLE_ID;
    style.textContent = [
      '@media only screen and (max-width: 798px) {',
      '#header .top-bar { position: relative; z-index: 10001; }',
      '#header .top-bar details[data-mobile-menu] { position: static; }',
      '#header .mobile-menu-container { display: none !important; opacity: 1 !important; visibility: visible !important; pointer-events: auto !important; }',
      'body.mobile-menu-open #header .mobile-menu-container { display: block !important; position: fixed !important; top: var(--yt-mobile-menu-top, 52px) !important; left: 0 !important; right: 0 !important; bottom: 0 !important; width: 100% !important; max-width: 100vw !important; margin: 0 !important; padding: 0 !important; overflow-x: hidden !important; overflow-y: auto !important; -webkit-overflow-scrolling: touch; z-index: 10000 !important; background: var(--yt-header-bg, var(--yt-shop-bg, #faf8f5)) !important; box-shadow: none !important; transform: none !important; }',
      'body.mobile-menu-open #header .mobile-menu-container .menu, body.mobile-menu-open #header #mobile_menu { display: block !important; visibility: visible !important; opacity: 1 !important; }',
      'body.mobile-menu-open.is-active #header { overflow: visible !important; bottom: auto !important; height: auto !important; max-height: none !important; }',
      '}',
    ].join('');
    document.head.appendChild(style);
  }

  function syncMobileMenuTop() {
    var header = document.getElementById('header');
    if (!header) return;
    document.documentElement.style.setProperty(
      '--yt-mobile-menu-top',
      `${Math.round(header.getBoundingClientRect().bottom)}px`,
    );
  }

  function setMobileMenuOpen(details, menu, icon, open) {
    syncMobileMenuTop();
    details.open = open;
    document.body.classList.toggle('mobile-menu-open', open);
    document.body.classList.toggle('is-active', open);
    if (icon) icon.classList.toggle('open', open);
    if (menu) menu.setAttribute('data-animation-state', open ? 'open' : 'closed');
  }

  function isInsideInjectedMegaPanel(link) {
    if (!link.closest('[data-meganav-target-container]')) return false;

    var block = link.closest('.mobile-mega-menu_block.sublink');
    if (!block) return false;

    // Menu column title <a> (direct child of block) should still accordion.
    if (link.parentElement === block) return false;

    return true;
  }

  function toggleSubmenu(link) {
    var submenu = link.nextElementSibling;
    if (!submenu || submenu.tagName !== 'UL') return false;

    if (isInsideInjectedMegaPanel(link)) return false;

    link.classList.toggle('active');
    var arrow = link.querySelector('.icon-down-arrow');
    if (arrow) arrow.classList.toggle('active');

    if (window.jQuery) {
      window.jQuery(submenu).slideToggle(200);
    } else {
      submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
    }

    return true;
  }

  function initMobileSubmenuAccordion() {
    var mobileMenu = document.getElementById('mobile_menu');
    if (!mobileMenu || mobileMenu.dataset.ytSubmenuInit === 'true') return;

    mobileMenu.dataset.ytSubmenuInit = 'true';

    mobileMenu.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link || !mobileMenu.contains(link)) return;
      if (!toggleSubmenu(link)) return;

      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  function initMobileMenuDrawerFix() {
    if (!window.matchMedia('(max-width: 798px)').matches) return;

    var details = document.querySelector('#header [data-mobile-menu]');
    if (!details || details.dataset.ytMenuFixInit === 'true') return;

    var trigger = details.querySelector('[data-mobile-menu-trigger]');
    var menu = details.querySelector('.mobile-menu-container');
    var icon = details.querySelector('[data-mobile-menu-icon]');
    if (!trigger || !menu) return;

    details.dataset.ytMenuFixInit = 'true';
    injectMobileMenuStyles();

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var open = !document.body.classList.contains('mobile-menu-open');
      setMobileMenuOpen(details, menu, icon, open);
    }, true);

    document.body.addEventListener('click', function (e) {
      if (!document.body.classList.contains('mobile-menu-open')) return;
      if (details.contains(e.target)) return;
      setMobileMenuOpen(details, menu, icon, false);
    });

    if (icon) {
      var observer = new MutationObserver(function () {
        var shouldOpen = icon.classList.contains('open');
        if (shouldOpen === document.body.classList.contains('mobile-menu-open')) return;
        setMobileMenuOpen(details, menu, icon, shouldOpen);
      });
      observer.observe(icon, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function refreshMeganav() {
    if (window.meganavManager && window.meganavManager.injectAll) {
      window.meganavManager.injectAll();
    }
  }

  function init() {
    initMobileSubmenuAccordion();
    initMobileMenuDrawerFix();
    refreshMeganav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
